import React from 'react';
import './CommonAddServices.css';
import CommonFormFields from '@pages/Forms/CommonFormFields';

type propsType = {
  formData: {
    [key: string]: any;
  };
  formState:any;
  handleFormChange:(value: string | boolean | any, key: string,  id: any,dataOptions: any,  code: any, changedData? : any )=>void;
};

const CommonAddService = ({ formData,formState,handleFormChange }: propsType) => {
  
  return (
    <div className="family_add_service_details_page">
      <form  data-testid="family-form-container" className="family_form_container">
        <CommonFormFields
          formData={formData}
          formState={formState}
          handleFormChange={handleFormChange}
        />
      </form>
    </div>
  );
};
export default CommonAddService;
